"use client";

import { useEffect, useState } from "react";
import type { SessionSummary } from "../../contracts";
import { AccountMenu, type AccountMenuCopy } from "./account-menu";
import { getSessionSummary } from "./gateway";
import { SignInButton } from "./sign-in-button";

export type AccountEntryProps = {
  signInLabel: string;
  menu: AccountMenuCopy;
  cabinetHref: string;
  locale: string;
  wide?: boolean;
};

// One lookup per page load, shared by the bar and the mobile-menu entries.
let pending: Promise<SessionSummary> | null = null;

function sessionSummary(): Promise<SessionSummary> {
  pending ??= getSessionSummary();
  return pending;
}

/**
 * The header's account slot on the prerendered homepage: "Sign in" until the
 * browser is known to hold a staff session, then the account menu.
 */
export function AccountEntry({ signInLabel, menu, cabinetHref, locale, wide = false }: AccountEntryProps) {
  const [session, setSession] = useState<SessionSummary>({ signedIn: false });

  useEffect(() => {
    let active = true;
    void sessionSummary().then((summary) => {
      if (active) setSession(summary);
    });
    return () => {
      active = false;
    };
  }, []);

  if (!session.signedIn) return <SignInButton label={signInLabel} wide={wide} />;
  return <AccountMenu copy={menu} displayName={session.displayName} email={session.email} cabinetHref={cabinetHref} locale={locale} wide={wide} />;
}
